import { Button } from '@/components/button';
import { useTranslation } from '@/contexts/i18n-context';

export function ResetPasswordLink() {
  const { t } = useTranslation();
  return (
    <Button variant="link" as="a" to="/forgot-password">
      {t('login.errors.resetPassword')}
    </Button>
  );
}
